/**
 * New / Used / Total — the three-line block a dealer asked for on every count.
 *
 * "If I got 18 leads today, are they new car leads? Are they used car leads?
 * I don't know." Unknown is a first-class bucket: a meaningful share of leads
 * carry only free-text vehicle interest and no inventory link, and hiding
 * them would make the two lines not add up to the total. It is suppressed
 * only when it is zero — and so is Demo, which is a classification in its own
 * right and must never be counted as Unclassified.
 */

export default function NewUsedSplit({ split, label, spark }) {
  const s = { new: 0, used: 0, demo: 0, unknown: 0, total: 0, ...(split || {}) };
  const total = s.total || (s.new + s.used + s.demo + s.unknown);
  const Row = ({ name, value, color, bold }) => (
    <div className="flex-between" style={{ padding: '4px 0', fontWeight: bold ? 700 : 400 }}>
      <span className="flex-row" style={{ alignItems: 'center', gap: 8 }}>
        {color && <span style={{ width: 10, height: 10, borderRadius: 2, background: color, display: 'inline-block' }} />}
        <span style={{ color: bold ? 'var(--text-primary)' : 'var(--text-secondary)' }}>{name}</span>
      </span>
      <span className="mono" style={{ fontSize: bold ? 16 : 14 }}>{value}</span>
    </div>
  );
  return (
    <div>
      {label && <div className="card-label" style={{ marginBottom: 6 }}>{label}</div>}
      <Row name="New" value={s.new} color="var(--info)" />
      <Row name="Used" value={s.used} color="var(--success)" />
      {s.demo > 0 && <Row name="Demo" value={s.demo} color="var(--warning)" />}
      {s.unknown > 0 && <Row name="Unclassified" value={s.unknown} color="var(--text-muted)" />}
      <div style={{ borderTop: '1px solid var(--border-subtle)', marginTop: 4 }}>
        <Row name="Total" value={total} bold />
      </div>
      {spark}
    </div>
  );
}

/** Inline "11 new · 5 used" for a tile's sub line. */
export function splitSub(split) {
  const s = { new: 0, used: 0, demo: 0, unknown: 0, ...(split || {}) };
  const parts = [`${s.new} new`, `${s.used} used`];
  if (s.demo > 0) parts.push(`${s.demo} demo`);
  if (s.unknown > 0) parts.push(`${s.unknown} unclassified`);
  return parts.join(' · ');
}
